export const CHECKOUT_TYPE_ORDER = "order";
export const CHECKOUT_TYPE_BUTTON = "button";
export const CHECKOUT_TYPE_QR = "qr";
export const PAYMENT_TYPE_POINTS = "POINTS";
export const PAYMENT_TYPE_CARD = "CARD";
export const POINTS_CHECK_ERROR_CARD = "CARD";
export const POINTS_CHECK_ERROR_ERROR = "ERROR";
export const POINTS_CHECK_ERROR_CATEGORY = "CATEGORY";
export const POINTS_CHECK_ERROR_OTHER = "OTHER";
export const CODE_300_TEST_CARD_NUMBER = 1234561231231234;




// WEBPACK FOOTER //
// ./client/constants.js